import $ from "jquery";

$("body").on("click", (e) => {
  if (
    !$(e.target).hasClass("site-header-mobile-navigation-list") &&
    !$(e.target).parents(".site-header-mobile-navigation-list").length
  ) {
    $(".site-header-mobile-navigation-list").removeClass("nav-is-visible");
  }
});

$(".site-header-mobile-navigation-trigger").on("click", () => {
  $(".site-header-mobile-navigation-list").toggleClass("nav-is-visible");
  return false;
});

$(window).resize(() => {
  $(".site-header-mobile-navigation-list").removeClass("nav-is-visible");
});
